import React from "react";
import { useParams, Navigate } from "react-router-dom";
import LicoresRegistro from "./LicoresRegistro";
import LicoresCalculo from "./LicoresCalculo";
import CodigosLicores from "./CodigosLicores";
import ClasificadorLicores from "./ClasificadorLicores";

const LicoresPage = () => {
  const { submodulo } = useParams();

  if (!submodulo) return <Navigate to="/licores/registro" replace />;

  switch (submodulo) {
    case "registro":
      return <LicoresRegistro />;
    case "calculo":
      return <LicoresCalculo />;
    case "codigos":
      return <CodigosLicores />;
    case "clasificador":
      return <ClasificadorLicores />;
    default:
      return <Navigate to="/licores/registro" replace />;
  }
};

export default LicoresPage;
